<template>
  <div class="search-form container sanitasForms">
    <div class="container__full">
      <sanitas-zip-chooser
        id="zipChooser"
        v-model="payload.zip"
        :required="false"
        :title="$t('core_medicalofficesearch_plz_title')"
        info-message-no-result=""
        :data-function="getLocation"
      />
    </div>
    <div class="container__half">
      <radio-group
        v-model="payload.radius"
        :items="items"
        required
        horizontal
        :title-label="$t('core_medicalofficesearch_radius_title')"
      />
    </div>
    <div class="container__full">
      <text-input
        v-model="payload.doc"
        :title-label="$t('core_medicalofficesearch_docpraxis_title')"
      ></text-input>
    </div>

    <div class="container__full">
      <text-input
        v-model="payload.doc_surname"
        :title-label="$t('core_medicalofficesearch_doc_title')"
      ></text-input>
    </div>
    <template v-if="variant === 2">
      <div class="container__full">
        <drop-down
          v-model="payload.network"
          :disabled="disableDropDown"
          :title-label="$t('core_medicalofficesearch_docnet_title')"
          :options="networks"
        >
        </drop-down>
      </div>
    </template>

    <div class="container__full" style="padding-top: 30px">
      <sanitas-button primary @click="$emit('submit')">
        {{ $t('core_medicalofficesearch_search_title') }}
      </sanitas-button>
      <template v-if="!hideCancel">
        <sanitas-button secondary @click="$emit('submit')">
          {{ $t('core_medicalofficesearch_cancel_title') }}
        </sanitas-button>
      </template>
    </div>
  </div>
</template>

<script>
import { useI36n } from '@jota-one/i36n/src/index.vue2'

import { client } from '@/helpers/http'

export default {
  name: 'SanitasMedicalOfficeForm',
  components: {
    DropDown: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/DropDown'
      )
    },
    SanitasZipChooser: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/SanitasZipChooser'
      )
    },
    SanitasButton: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/SanitasButton'
      )
    },
    TextInput: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/TextInput'
      )
    },
    RadioGroup: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/RadioGroup'
      )
    },
  },
  props: {
    hideCancel: Boolean,
    disableDropDown: Boolean,
    isInvalid: Boolean,

    /**
     * there are 3 different variants:
     *  0: no additional fields
     *  1: vertragsbeginn
     *  2: netzwerk
     *  3: vertragsbeginn + netzwerk
     */
    variant: {
      type: Number,
      default: 0,
    },

    ranges: {
      type: Array,
      default: () => [],
    },

    networks: {
      type: Array,
      default: () => [],
    },

    payload: {
      type: Object,
      default: () => ({
        date: undefined,
        zip: undefined,
        radius: 0,
        doc: undefined,
        doc_surname: undefined,
        network: '',
      }),
    },
  },

  setup() {
    const { $label } = useI36n()

    return {
      $t: $label,
    }
  },

  computed: {
    items() {
      return this.ranges.map(el => {
        return {
          value: el.value,
          text: this.$t(el.label),
        }
      })
    },
  },
  methods: {
    async getLocation(_, query) {
      return client('api')
        .get('masterdata/location-search', {
          q: encodeURI(query),
          type: 'POSTAL',
        })
        .then(locations =>
          locations.map(l =>
            Object.assign({}, l, {
              zipCodeAddOn: l.zipCodeAddOn || l.zipCodeAddon,
            }),
          ),
        )
    },
  },
}
</script>

<style lang="postcss" scoped>
.container {
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;

  &_full,
  &__half {
    flex-grow: 1;
    flex-basis: auto;
    flex-shrink: 0;
  }
}
</style>
